import { Box, Container, Typography } from "@mui/material";


export default function Footer({ config = {} }) {
  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        bgcolor: "#0f172a",
        color: "#94a3b8",
      }}
    >
      <Container maxWidth="xl">
        <Typography sx={{ fontSize: ".9rem", textAlign: "center" }}>
          {config?.FooterText || config?.Title || ""}
        </Typography>
      </Container>
    </Box>
  );
}
